var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '../Text';
const Ellipsis = (_a) => {
    var { children, sx } = _a, props = __rest(_a, ["children", "sx"]);
    return (_jsx(Text, Object.assign({ sx: Object.assign({ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }, sx) }, props, { children: children })));
};
export default Ellipsis;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWxsaXBzaXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb21tb25zL0VsbGlwc2lzL0VsbGlwc2lzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFFQSxPQUFPLEVBQUUsSUFBSSxFQUFhLE1BQU0sU0FBUyxDQUFDO0FBRTFDLE1BQU0sUUFBUSxHQUFrQixDQUFDLEVBQTBCLEVBQUUsRUFBRTtRQUE5QixFQUFFLFFBQVEsRUFBRSxFQUFFLE9BQVksRUFBUCxLQUFLLGNBQXhCLGtCQUEwQixDQUFGO0lBQU8sT0FBQSxDQUM5RCxLQUFDLElBQUksa0JBQ0gsRUFBRSxrQkFDQSxZQUFZLEVBQUUsVUFBVSxFQUN4QixVQUFVLEVBQUUsUUFBUSxFQUNwQixRQUFRLEVBQUUsUUFBUSxJQUNmLEVBQUUsS0FFSCxLQUFLLGNBRVIsUUFBUSxJQUNKLENBQ1IsQ0FBQTtDQUFBLENBQUM7QUFFRixlQUFlLFFBQVEsQ0FBQyJ9